import React from 'react';

const Home = () => <div>home</div>;

export default Home;
